<template>
  <button
    v-ripple="isCapacitor"
    class="focus:outline-none focus:shadow-md font-semibold font-inter gap-2 flex justify-center items-center"
    :class="[buttonType, sizeClasses, `size-${size}`]"
    :type="type"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <span v-if="icon">
      <icon class="icon" icon="arrowLeft" color="primary-purple-700" height="11.67" width="11.67" />
    </span>
    <slot>Add Title</slot>
  </button>
</template>

<script>
import icon from '@components/icons/icon.vue'
import { isCapacitor } from '@src/utils/platformUtil.js'

export default {
  components: {
    icon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    button: {
      type: String,
      default: '',
    },
    icon: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'base',
      validator: (value) => ['xs', 'sm', 'md', 'base', 'lg', 'xl'].includes(value),
    },
  },
  emits: ['click'],

  computed: {
    isCapacitor() {
      return isCapacitor()
    },
    buttonType() {
      if (this.button === 'primary') return 'primary-button text-white'
      if (this.button === 'primary-previous') return 'primary-previous-button text-white'
      if (this.button === 'external') {
        return 'bg-white hover:bg-gray-100 border border-gray-300 text-gray-700 rounded-xl shadow-md px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base'
      }
      return 'primary-button-outline'
    },
    sizeClasses() {
      if (this.size === 'base') return 'text-sm sm:text-base'

      const sizeMap = {
        xs: 'text-[13px] !px-3 !py-1.5 !h-8 !min-h-8 !min-w-20 sm:!min-w-20 sm:!min-h-8 rounded-md shadow-sm',
        sm: 'text-sm !px-3 !py-1.5 !h-7 !min-h-7 !min-w-20 sm:!min-w-20 sm:!min-h-7',
        md: 'text-sm !px-4 !py-2 !h-8 !min-h-8 !min-w-24 sm:!min-w-24 sm:!min-h-8',
        lg: 'text-base !px-5 !py-2.5 !h-10 !min-h-10 !min-w-28 sm:!min-w-28 sm:!min-h-10',
        xl: 'text-lg !px-6 !py-3 !h-12 !min-h-12 !min-w-32 sm:!min-w-32 sm:!min-h-12',
      }
      return sizeMap[this.size] || 'text-sm sm:text-base'
    },
  },
}
</script>

<style scoped>
/* Override primary-button classes for custom sizes */
button.size-xs {
  min-width: 80px;
  min-height: 32px;
  padding: 6px 12px;
  height: 32px;
  border-radius: 8px;
}

button.size-sm {
  min-width: 80px;
  min-height: 28px;
  padding: 6px 12px;
  height: 28px;
}

button.size-md {
  min-width: 96px;
  min-height: 32px;
  padding: 8px 16px;
  height: 32px;
}

button.size-lg {
  min-width: 112px;
  min-height: 40px;
  padding: 10px 20px;
  height: 40px;
}

button.size-xl {
  min-width: 128px;
  min-height: 48px;
  padding: 12px 24px;
  height: 48px;
}

/* Override media query for custom sizes */
@media (min-width: 640px) {
  button.size-xs {
    min-width: 80px;
    min-height: 32px;
  }

  button.size-sm {
    min-width: 80px;
    min-height: 28px;
  }

  button.size-md {
    min-width: 96px;
    min-height: 32px;
  }

  button.size-lg {
    min-width: 112px;
    min-height: 40px;
  }

  button.size-xl {
    min-width: 128px;
    min-height: 48px;
  }
}
</style>
